import type { DynamicClient } from '../../../client/types';
import { NoWalletProviderFoundError } from '../../../errors/NoWalletProviderFoundError';
import { getWalletProviderFromWalletAccount } from '../utils/getWalletProviderFromWalletAccount';
import type { WalletAccount } from '../walletAccount';

type DisconnectWalletAccountParams = {
  walletAccount: WalletAccount;
};

/**
 * This function disconnects the specified wallet account with the wallet provider.
 *
 * The wallet account is not removed from the user's profile or from dynamic's state,
 * it is only responsible for terminating the connection with the wallet provider.
 */
export const disconnectWalletAccount = async (
  { walletAccount }: DisconnectWalletAccountParams,
  client: DynamicClient
): Promise<void> => {
  try {
    const walletProvider = getWalletProviderFromWalletAccount(
      { walletAccount },
      client
    );

    await walletProvider.disconnectWalletAccount?.({ walletAccount });
  } catch (error) {
    // If there is no wallet provider, we don't need to do anything
    // as the wallet account is not connected. It's fine to ignore this error.
    if (error instanceof NoWalletProviderFoundError) {
      return;
    }

    throw error;
  }
};
